import {otaProductList,otaProductDetails,otaDddProduct,otaUpProduct,otaDelProduct} from 'api/otaProduct';
import {otaSyncProduct} from "../../api/otaSyncProduct";
import Cookies from 'js-cookie';

const otaProduct = {
    state: {
        account: '',
        status: '',
        email: '',
        uid: Cookies.get('uid'),
        acc: Cookies.get('acc'),
        avatar: '',
        introduction: '',
        roles: [],
        setting: {
            articlePlatform: []
        }
    },

    mutations: {

    },

    actions: {
        otaProductList({commit},params) {
            return new Promise((resolve, reject) => {
                otaProductList(params.productId, params.productName,params.agent,params.providerId, params.onSale,params.ccList, params.zoneName,params.psize, params.currentPage).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        otaProductDetails({commit}, productId) {
            return new Promise((resolve, reject) => {
                otaProductDetails(productId).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        otaAddProduct({commit},params) {
            return new Promise((resolve, reject) => {
                otaAddProduct(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        otaUpProduct({commit},params) {
            return new Promise((resolve, reject) => {
                otaUpProduct(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        otaDelProduct({commit},params) {
            return new Promise((resolve, reject) => {
                otaDelProduct(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        otaSyncProduct({commit},params) {
            return new Promise((resolve, reject) => {
                otaSyncProduct(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
    }
};

export default otaProduct;



// WEBPACK FOOTER //
// ./src/store/modules/otaProduct.js